<template>
  <div>
    <div class="table-responsive col-lg-12">
      <table class="table table-striped table-bordered table-hover">
        <thead>
        <tr>
          <th>Date</th>
          <th>Users</th>
        </tr>
        </thead>
        <tbody>
      <tr v-for="(day, date) in reports.data" :key="date">
        <td>{{ date }}</td>
        <td>
          <table class="table table-striped table-bordered table-hover">
            <thead>
            <tr>
              <th>Assignee</th>
              <th v-for="action in actions" :key="'act-' + action.key"><i :class="action.icon" :title="action.text"></i></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="key in Object.keys(day)" :key="date+key" v-if="key !== '_sum'">
              <td>{{ day[key].assignee.name}}</td>
              <td class="col-lg-1" v-for="act in actions" :key="date+day[key].assignee.id+act.key">
                {{ day[key].actions[act.key] ? day[key].actions[act.key].count : 0 }}
              </td>
            </tr>
            </tbody>
            <thead>
            <tr>
              <th>Total:</th>
              <th v-for="action in actions" :key="'act-foot-' + action.key">{{ day['_sum'][action.key] || 0 }}</th>
            </tr>
            </thead>
          </table>
        </td>
      </tr>

      </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      actions: [
        {
          key: 'added',
          text: 'Added',
          icon: 'fa fa-plus'
        },
        {
          key: 'built',
          text: 'Built',
          icon: 'fas fa-hammer'
        },
        {
          key: 'content',
          text: 'Content',
          icon: 'fa fa-file'
        },
        {
          key: 'content-added',
          text: 'Content Added',
          icon: 'fas fa-file-upload'
        },
        {
          key: 'qa',
          text: 'QA',
          icon: 'fa fa-check'
        },
        {
          key: 'site-moved',
          text: 'Site Moved',
          icon: 'fa fa-arrow-right'
        },
        {
          key: 'domain-moved',
          text: 'Domain Moved',
          icon: 'fas fa-people-arrows'
        },
        {
          key: 'delivered',
          text: 'Delivered',
          icon: 'fa fa-check'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      reports: 'getReport'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Build/Report/List.vue